import env from './env';

import parseEnv from './parseEnv';

parseEnv(env);

export default env;



// WEBPACK FOOTER //
// ./app/environment/index.js